import React, { useContext } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as dashboardServiceActions from "../../store/dashboardService/actions";
import { ApplicationState } from "../../store";
import { Link } from "react-router-dom";
import { UserService } from "../../store/loginService/types";
import { ezsServiceIds } from "../../config/UserServicesList";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { CommonContext } from "../../CommonContextProvider";
import * as LoginActions from "../../store/loginService/actions";
import { getFormattedDate } from "../../util/dateFormatting";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const DashboardService = () => {
    const dispatch = useDispatch();
    const { creditDynamicRoute, redirectPageTo }: any = useContext(CommonContext);
    const requestAllTuServices = () => dispatch(dashboardServiceActions.actionCreators.getAllTUServiceWithLabel());
    const hasLanguageChanged = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.hasLanguageChanged ? state.loggedInUser.userInfo?.hasLanguageChanged : false
    );
    const dashboardServiceData = () => dispatch(dashboardServiceActions.actionCreators.getDashboardServiceData(hasLanguageChanged));
    const userServicesData = useSelector((state: ApplicationState) =>
        state.loggedInUser ? (state.loggedInUser.userServiceDetails ? state.loggedInUser.userServiceDetails.userServices : []) : []
    );
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    
    const SetLanguageChange = (updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.LanguageChange(updateUsersLang));
    const serviceGroupData = useSelector((state: ApplicationState) => (state.dashboardServiceState ? state.dashboardServiceState.dashboardServices : []));

    const isDataLoading = useSelector((state: ApplicationState) => (state.dashboardServiceState ? state.dashboardServiceState.isLoading : true));

    const isL3Authenticated: boolean = useSelector(
        (state: ApplicationState) => state?.csidUserStatusState?.csidUserStatus?.["auth-status"]?.toLowerCase() === "authenticated" || false
    );

    const activeCategoryCount = serviceGroupData != null ? serviceGroupData?.filter((x) => x.active == true).length : 0;
    const cssClassName = activeCategoryCount === 1 ? "col-md-12" : activeCategoryCount === 2 ? "col-md-6" : activeCategoryCount === 3 ? "col-md-4" : "col-md-3";
    const { t: tLang } = useTranslation();

    const IDRServiceList: Array<string> = [
        ezsServiceIds.idRestorationProInd,
        ezsServiceIds.idRestorationProWith25kInsurance,
        ezsServiceIds.idDRestorationProWith1mInsurance,
        ezsServiceIds.familyIdRestorationPro,
        ezsServiceIds.familyIdRestorationProWith25kInsurance,
        ezsServiceIds.familyIdRestorationProWith25kInsuranceAndUEFT,
        ezsServiceIds.familyIdRestorationProWith1MInsurance,
    ];

    const checkIDROnly = () => {
        let serviceData: UserService[] = Array();
        Object.assign(serviceData, userServicesData);
        serviceData = serviceData.filter((s) => s.active === true);
        if (serviceData != null && serviceData.length > 0) {
            serviceData.forEach(function (data: UserService) {
                if (IDRServiceList.some((x) => x === data.serviceCode)) {
                    const idx = serviceData.indexOf(data);
                    if (idx !== -1) {
                        serviceData.splice(idx, 1);
                    }
                }
            });

            return serviceData != null && serviceData.length > 0 ? false : true;
        }
        return false;
    };

    const isIDROnly = checkIDROnly();

    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );

    let isVisible = hasEducationAndBreach;
    const cssIDRClassName = isVisible ? "col-md-3" : "col-md-6";

    useEffect(() => {
        requestAllTuServices();
        dashboardServiceData();
        if (hasLanguageChanged)
            SetLanguageChange(false);
    }, []);
    
    return (
        <React.Fragment>
            <div className="box">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-text has-actions">
                            <h2 className="box-title heading-title">{tLang("dashboard.servicesWidget.title")}</h2>
                        </div>
                    </div>
                    <div className="box-actions">
                        <a
                            href="javascript(void)"
                            onClick={(e) => {
                                e.preventDefault();
                                redirectPageTo("/manage-account/my-services");
                            }}
                            className="default_link"
                            
                        >
                            {tLang("dashboard.servicesWidget.manageServicesLink")}
                        </a>
                    </div>
                </div>
                {!isDataLoading ? (
                    <>
                        {!isIDROnly ? (
                            <div className="box-content">
                                <div id="services">
                                    <div className="row">
                                        {serviceGroupData != null &&
                                            serviceGroupData.map((data: any, index: number) =>
                                                data.active === true ? (
                                                    <div className={"col-xs-12 " + cssClassName + " col-gutter-vertical"} key={index}>
                                                        <div className="service-container">
                                                            <Link
                                                                to={data.categoryName === "Credit" ? creditDynamicRoute : data.categoryUrl}
                                                                style={{ textDecoration: "none" }}
                                                            >
                                                                <div className="service-icon">
                                                                    <span className="service-icon-container">
                                                                        <RenderIcons iconName={data.categoryIconClass} />
                                                                    </span>
                                                                </div>
                                                                <div className="service-title">
                                                                    <h3>
                                                                        {data.categoryName === "Identity"
                                                                            ? tLang("dashboard.servicesWidget.identityService")
                                                                            : data.categoryName === "Credit"
                                                                                ? tLang("dashboard.servicesWidget.creditService")
                                                                                : data.categoryName === "Financial"
                                                                                    ? tLang("dashboard.servicesWidget.FinancialService")
                                                                                    : data.categoryName === "Social"
                                                                                        ? tLang("dashboard.servicesWidget.SocialService")
                                                                            : data.categoryName}
                                                                    </h3>
                                                                </div>
                                                            </Link>
                                                            <div className="service-content">
                                                                {data.categoryText !== "Upgrade" ? (
                                                                    <span>
                                                                        {data.categoryName === "Credit" && !isBusinessUser && !isL3Authenticated ? tLang("dashboard.servicesWidget.verifyIdentity") 
                                                                        :data.categoryText === "Last Scan"
                                                                            ? tLang("dashboard.servicesWidget.lastScan") + ":"
                                                                                : data.categoryText + ":"
                                                                        }
                                                                    </span>
                                                                ) : (
                                                                    <Link to="/manage-account/protection-plan" className="default_link">
                                                                            {data.categoryText}
                                                                    </Link>
                                                                )}

                                                                <span>
                                                                    {data.categoryName === "Credit" && !isBusinessUser && !isL3Authenticated ? "" 
                                                                    : getFormattedDate(
                                                                        i18nService.get("Country"),
                                                                        data.lastUpdateDate != null ? data.lastUpdateDate : data.lastScanDate
                                                                    )}
                                                                </span>

                                                                <span className="status-alert">
                                                                    {data.newAlertCount > 0 && (
                                                                        <Link
                                                                            to="/monitoring"
                                                                            className="hub-alert-count"
                                                                            style={{
                                                                                display: data.newAlertCount > 0 ? "visible" : "none",
                                                                                textDecoration: "none",
                                                                                color: "#AB170D",

                                                                            }}
                                                                        >
                                                                            <em className={data.newAlertCount > 0 ? "las la-exclamation-triangle" : ""}></em>
                                                                            {data.newAlertCount > 0
                                                                                ? data.newAlertCount === 1
                                                                                    ? data.newAlertCount +" "+tLang("dashboard.servicesWidget.alert")
                                                                            : data.newAlertCount +" "+tLang("dashboard.servicesWidget.alerts")
                                                                                : ""}
                                                                        </Link>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )
                                            )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="box-content">
                                <div id="services">
                                    <div className="row">
                                        <Link to="/identity-vault/secure-storage" style={{ textDecoration: "none" }}>
                                            <div className={"col-xs-12 " + cssIDRClassName + " col-gutter-vertical"}>
                                                <div className="service-container">
                                                    <div className="service-icon">
                                                        <span className="service-icon-container">
                                                            <RenderIcons iconName="user-shield" />
                                                        </span>
                                                    </div>
                                                    <div className="service-title">
                                                        <h3>Identity Vault</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to="/identity-vault/password-manager" style={{ textDecoration: "none" }}>
                                            <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                                <div className="service-container">
                                                    <div className="service-icon">
                                                        <span className="service-icon-container">
                                                            <RenderIcons iconName="key" />
                                                        </span>
                                                    </div>
                                                    <div className="service-title">
                                                        <h3>Password Manager</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                        {isVisible ? (
                                            <Link to="/resources" style={{ textDecoration: "none" }}>
                                                <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                                    <div className="service-container">
                                                        <div className="service-icon">
                                                            <span className="service-icon-container">
                                                                <RenderIcons iconName="graduation-cap" />
                                                            </span>
                                                        </div>
                                                        <div className="service-title">
                                                            <h3>Educational Articles</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        ) : (
                                            <></>
                                        )}
                                        {isVisible ? (
                                            <Link to="/resources/breaches-and-scams" style={{ textDecoration: "none" }}>
                                                <div className="col-xs-12 col-md-3 col-gutter-vertical">
                                                    <div className="service-container">
                                                        <div className="service-icon">
                                                            <span className="service-icon-container">
                                                                <RenderIcons iconName="user-secret" />
                                                            </span>
                                                        </div>
                                                        <div className="service-title">
                                                            <h3>Breaches & Scams</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="box loading"></div>
                )}
            </div>
        </React.Fragment>
    );
};

export default DashboardService;
